import { render, staticRenderFns } from "./TeklifOnayMesaj.vue?vue&type=template&id=a65aab2c&"
import script from "./TeklifOnayMesaj.vue?vue&type=script&lang=js&"
export * from "./TeklifOnayMesaj.vue?vue&type=script&lang=js&"
import style0 from "./TeklifOnayMesaj.vue?vue&type=style&index=0&id=a65aab2c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports